import { styled } from '@mui/material/styles'
import MuiButton from '@mui/material/Button'

export const TileButton = styled(MuiButton)({
  borderRadius: 0,
  textTransform: 'none',
  textAlign: 'left',
  '&:hover': {
    backgroundColor: 'transparent'
  }
})

export default TileButton
